import { z } from 'zod';

export enum RoleName {
  Lender = 'Lender',
  Affiliate = 'Affiliate',
  Partner = 'Partner',
  Service = 'Service',
  Customer = 'Customer',
  CustomerVerifiedEmail = 'CustomerVerifiedEmail',
  Person = 'Person',
  Developer = 'Developer',
  InsuranceBroker = 'InsuranceBroker',
  LegacyPlatform = 'LegacyPlatform',
  Sales = 'Sales',
  SecuredSales = 'SecuredSales',
  Telemarketing = 'Telemarketing',
  Subscriber = 'Subscriber',
  DeadLetterQueue = 'DeadLetterQueue',
  Super = 'Super',
  Manager = 'Manager',
  BusinessManager = 'BusinessManager',
  TelemarketingLimited = 'TelemarketingLimited',
}

export const RoleSchema = z.object({
  Name: z.nativeEnum(RoleName).or(z.string()),
  Country: z.string().optional(),
});

export type Role = z.infer<typeof RoleSchema>;
